import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Form } from './Form'
import { useAppDispatch } from '../../hooks/useAppDispatch'
import { EmailTextBox } from '../TextBox/EmailTextBox'
import { VerificationCodeTextBox } from '../TextBox/VerificationCodeTextBox'
import { Button, ButtonThemeType } from '../Button'
import { ButtonType } from '../Button/ButtonType.constants'
import { AuthHelper } from '../../helpers/AuthHelper'
import { showAlert } from '../../states/alerts/actions'
import { AuthException } from '@laputan/core/dist/types/Auth.types'
import { showMessageModal } from '../../states/modals/actions'
import { resendSignUpConfirmationCode } from '../../states/currentUser/actions'

type ConfirmEmailFormProps = {
  email: string
}

type ConfirmEmailFields = {
  email: string
  verificationCode: string
}

const StyledButton = styled(Button)`
  margin-top: 1rem;
`

const ConfirmEmailForm = ({ email }: ConfirmEmailFormProps) => {
  const dispatch = useAppDispatch()
  const [formFields, setFormFields] = useState<ConfirmEmailFields>({
    email,
    verificationCode: '',
  })
  useEffect(() => {
    dispatch(resendSignUpConfirmationCode({ email }))
  }, [])
  return (
    <Form
      formFields={formFields}
      onChange={(ff) => setFormFields(ff as ConfirmEmailFields)}
      onSubmit={() =>
        AuthHelper.confirmSignUp(email, formFields.verificationCode)
          .then(() => {
            dispatch(
              showMessageModal({
                header: 'Congratulations',
                message: (
                  <div>
                    Your email has been verified
                    <br />
                    Thank you for signing up
                  </div>
                ),
              })
            )
          })
          .catch((ex: AuthException) => {
            const { message } = ex
            dispatch(showAlert(message))
          })
      }
    >
      <EmailTextBox labelText="Email" name="email" disabled />
      <VerificationCodeTextBox
        labelText="Verification Code"
        name="verificationCode"
        validation="verificationCode"
        required
      />
      <StyledButton
        label="Submit"
        theme={ButtonThemeType.PRIMARY}
        type={ButtonType.SUBMIT}
      >
        Submit
      </StyledButton>
    </Form>
  )
}

export default ConfirmEmailForm
